<div class='logo-container'>
  <fw-app-icon color='light' variant='static' size='medium' fontColor='base' icon='flywheel-mark-logo'
    class='remove-icon-padding'>
  </fw-app-icon>
  <h3 style='flex: 1'>
    {{ 'sidebar.labels.flywheel' | translate }}
  </h3>
</div>
<div *ngIf='exhaustiveMode$ | async' class='admin-mode'>
  <fw-icon>crown-style-circle</fw-icon>
  <h4>{{ 'sidebar.labels.adminMode' | translate }}</h4>
</div>
<div class="search-item">
  <fw-navbar-item test-id="sidebar-search"  href='#/search' (click)="openSearch()"
    [title]="'sidebar.labels.search' | translate" icon="search"></fw-navbar-item>
  <fw-menu-separator></fw-menu-separator>
</div>

<fw-navbar>
  <fw-navbar-header>
    {{ 'sidebar.labels.data.sectionTitle' | translate }}
  </fw-navbar-header>
  <fw-navbar-item test-id="projects" href='#/projects' [title]="'sidebar.labels.data.projects' | translate"
    [selected]="isSelected('projects')" [subItemsOpen]='(recentProjects$ | async)?.length>0' icon='folder-open'>
    <fw-navbar-sub-item *ngFor='let project of recentProjects$ | async' [title]='project.label'
      [href]="'#/projects/' + project._id" [selected]="isSelected('projects/' + project._id)" [value]='project.label'
      [tooltipText]="(project.group || 'unknown') + ' / ' + project.label" [showTooltip]="true">
    </fw-navbar-sub-item>
  </fw-navbar-item>

  <fw-navbar-item test-id='sidebar-sessions' href='#/sessions/' [title]="'sidebar.labels.data.sessions' | translate"
    [selected]="isSelected('sessions')" icon='files-library-content'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='collectionsEnabled' test-id='sidebar-collections' href='#/collections'
    [title]="'sidebar.labels.data.collections' | translate" [selected]="isSelected('collections')" icon='files-library'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='showNewTasks' test-id='sidebar-tasks' href='#/tasks'
    [title]="'sidebar.labels.data.tasks' | translate" [selected]="isSelected('tasks')" icon="checklist">
  </fw-navbar-item>
  <fw-navbar-item *ngIf='showOldTasksOnly' test-id='sidebar-tasks' href='#/legacy-tasks'
    [title]="'sidebar.labels.data.tasks' | translate" [selected]="isSelected('legacy-tasks')" icon='checklist'>
    <p *ngIf="taskCount$ | async" class="tasks-badge">{{ taskCount$ | async | number }}</p>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='showLegacyTasks' test-id='sidebar-legacy-tasks' href='#/legacy-tasks'
    [title]="'sidebar.labels.data.legacyTasks' | translate" [selected]="isSelected('legacy-tasks')" icon='checklist'>
    <p *ngIf="taskCount$ | async" class="tasks-badge">{{ taskCount$ | async | number }}</p>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='dicomUploadEnabled' test-id='sidebar-collections' href='#/dicom-uploader/'
    [title]="'sidebar.labels.data.uploadDicom' | translate" [selected]="isSelected('dicom-uploader')" icon='upload'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf="importEnabled" test-id='sidebar-add-data' href='#/add-data/'
    [title]="'sidebar.labels.data.addData' | translate" [selected]="isSelected('add-data')" icon='add-new-create'>
  </fw-navbar-item>

  <ng-container *ngIf='exchangeEnabled'>
    <fw-navbar-header>
      {{ 'sidebar.labels.exchange.sectionTitle' | translate }}
    </fw-navbar-header>
    <fw-navbar-item test-id='sidebar-explore-data' href='#/exchange/data'
      [title]="'sidebar.labels.exchange.explore' | translate" [selected]="isSelected('exchange/data')"
      icon='server-databases-connect'>
    </fw-navbar-item>
    <fw-navbar-item *ngIf='exchangeAdminEnabled' test-id='sidebar-exchange-admin' href='#/exchange/admin'
      [title]="'sidebar.labels.exchange.manageAccess' | translate" icon='arrange-filter-sort'>
    </fw-navbar-item>
  </ng-container>

  <fw-navbar-header>
    {{ 'sidebar.labels.compute.sectionTitle' | translate }}
  </fw-navbar-header>
  <fw-navbar-item test-id='sidebar-jobs' href='#/jobs/' [title]="'sidebar.labels.compute.jobsLog' | translate"
    [selected]="isSelected('jobs')" icon='settings-select'>
  </fw-navbar-item>
  <fw-navbar-item test-id='sidebar-gears' href='#/gears/' [title]="'sidebar.labels.compute.installedGears' | translate"
    [selected]="isSelected('gears')" icon='settings-gear-square'>
  </fw-navbar-item>

  <fw-navbar-header>
    {{ 'sidebar.labels.reporting.sectionTitle' | translate }}
  </fw-navbar-header>
  <fw-navbar-item test-id='sidebar-reports' href='#/report/'
    [title]="'sidebar.labels.reporting.projectReport' | translate" [selected]="isSelected('report')" icon='pie-chart'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='isSiteAdmin$ | async' test-id='sidebar-usage' href='#/usage/'
    [title]="'sidebar.labels.reporting.usageReport' | translate" [selected]="isSelected('usage')"
    icon='chart-trend-square'>
  </fw-navbar-item>

  <fw-navbar-header>
    {{ 'sidebar.labels.admin.sectionTitle' | translate }}
  </fw-navbar-header>
  <fw-navbar-item *ngIf='isSiteAdmin$ | async' test-id='sidebar-users' href='#/admin/users'
    [title]="'sidebar.labels.admin.users' | translate" [selected]="isSelected('admin/users')" icon='user'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='showGroups$ | async' test-id='sidebar-groups' href='#/admin/groups'
    [title]="'sidebar.labels.admin.groups' | translate" [selected]="isSelected('admin/groups')" icon='user-group'>
  </fw-navbar-item>
  <fw-navbar-item test-id='sidebar-roles' href='#/admin/roles' [title]="'sidebar.labels.admin.roles' | translate"
    [selected]="isSelected('admin/roles')" icon='user-lock'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf="tasksRefactorEnabled && isSiteAdmin$ | async" test-id="sidebar-staffing-pools" href="#/admin/staffing-pools"
    [title]="'sidebar.labels.admin.staffingPools' | translate" [selected]="isSelected('admin/staffing-pools')" icon="user-profile-cards-pool">
  </fw-navbar-item>
  <fw-navbar-item *ngIf='isSiteAdmin$ | async' test-id='sidebar-applications' href='#/admin/applications'
    [title]="'sidebar.labels.admin.applications' | translate" [selected]="isSelected('admin/applications')"
    icon='files'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='isSiteAdmin$ | async' test-id='sidebar-interfaces' href='#/admin/interfaces'
    [title]="'sidebar.labels.admin.interfaces' | translate" [selected]="isSelected('admin/interfaces')"
    icon='data-tree'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='dataViewsNon21CFREnabled && (isSiteAdmin$ | async)' test-id='sidebar-dataviews'
    href='#/admin/dataviews' [title]="'sidebar.labels.admin.dataViews' | translate"
    [selected]="isSelected('admin/dataviews')" icon='layout-grid'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='isSiteAdmin$ | async' test-id='sidebar-access' href='#/accesslog/'
    [title]="'sidebar.labels.admin.accessLog' | translate" [selected]="isSelected('accesslog')" icon='show-visible'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='isSiteAdmin$ | async' test-id='sidebar-rules' href='#/rules'
    [title]="'sidebar.labels.admin.gearRulesTemplates' | translate" [selected]="isSelected('rules')"
    icon='substract-group'>
  </fw-navbar-item>
  <fw-navbar-item *ngIf='isSiteAdmin$ | async' test-id='sidebar-settings' href='#/settings'
    [title]="'sidebar.labels.admin.settings' | translate" [selected]="isSelected('settings')" icon='setting-gear'>
  </fw-navbar-item>

</fw-navbar>
